// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1wzRU","label":"Completed_label__1t_bq"};